/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  "/auth/register/options": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Begin local passkey account registration, optionally bound to an organization invitation. */
    post: operations["beginPasskeyRegistration"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/register/verify": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Verify a passkey and atomically create the account, owner workspace, and any invited membership. */
    post: operations["finishPasskeyRegistration"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/login/options": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Begin discoverable passkey sign-in. */
    post: operations["beginPasskeyLogin"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/login/verify": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Verify a discoverable passkey and create a fresh browser session. */
    post: operations["finishPasskeyLogin"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/recovery/options": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Verify a one-time recovery code to begin replacement-passkey registration.
     * @description Unknown handles and invalid, used, or revoked codes return the same public failure. The code is consumed only when replacement-passkey registration commits successfully.
     */
    post: operations["beginPasskeyRecovery"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/recovery/verify": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Register the replacement passkey and create a new browser session. */
    post: operations["finishPasskeyRecovery"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/logout": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Revoke the current browser session. */
    post: operations["logoutBrowser"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/logout-all": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Revoke every browser session for the current account. */
    post: operations["logoutAllBrowsers"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/passkeys": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List active passkeys for the current account. */
    get: operations["listPasskeys"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/passkeys/options": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Begin adding a passkey to the authenticated account. */
    post: operations["beginAdditionalPasskey"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/passkeys/verify": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Verify and add another passkey. */
    post: operations["finishAdditionalPasskey"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/passkeys/{passkey_id}": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Revoke one passkey without removing the account's final usable recovery method. */
    delete: operations["revokePasskey"];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/recovery-codes": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Return only the number of active recovery codes. */
    get: operations["getRecoveryCodeStatus"];
    put?: never;
    /** Atomically revoke old recovery codes and generate a new one-time-display set. */
    post: operations["replaceRecoveryCodes"];
    /** Revoke active recovery codes while retaining at least one active passkey. */
    delete: operations["revokeRecoveryCodes"];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/device/pairings": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Start a short-lived native desktop pairing.
     * @description Origin-less requests are accepted only for this native endpoint; browser
     *     cross-origin requests remain denied by Origin and Fetch Metadata checks.
     *     The response contains `device_code`, `user_code`, `expires_at`, and
     *     `interval_seconds`; it does not return a browser verification URI.
     */
    post: operations["startDesktopPairing"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/device/pairings/poll": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Poll a pairing at the advertised interval and receive credentials exactly once. */
    post: operations["pollDesktopPairing"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/device/pairings/decision": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Approve or deny a pairing as the authenticated browser actor. */
    post: operations["decideDesktopPairing"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/auth/device/refresh": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Transactionally rotate a desktop refresh token.
     * @description Reuse of a consumed refresh token revokes the entire credential family as compromised.
     */
    post: operations["refreshDesktopCredential"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/me": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** Get the authenticated actor and current memberships. */
    get: operations["getCurrentActor"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/invitations/inspect": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Safely inspect an available invitation capability.
     * @description Invalid, malformed, expired, revoked, accepted, and concurrently consumed capabilities return the same unavailable response. Raw tokens are accepted only in the request body and are never persisted.
     */
    post: operations["inspectInvitation"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/invitations/accept": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Atomically consume an invitation and join its organization.
     * @description Acceptance is single-use and race-safe. Unavailable capabilities return the same response regardless of why they cannot be accepted.
     */
    post: operations["acceptInvitation"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/organizations": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /** List organizations visible to the actor. */
    get: operations["listOrganizations"];
    put?: never;
    /** Create an organization with the actor as owner. */
    post: operations["createOrganization"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/organizations/{organization_id}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    /** Get one organization visible to the actor. */
    get: operations["getOrganization"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/organizations/{organization_id}/memberships": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    /** List organization memberships. */
    get: operations["listMemberships"];
    put?: never;
    /** Add an existing local account to an organization. */
    post: operations["createMembership"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/organizations/{organization_id}/memberships/{membership_id}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
        membership_id: components["parameters"]["MembershipId"];
      };
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Change a member role or revoke membership. */
    patch: operations["updateMembership"];
    trace?: never;
  };
  "/organizations/{organization_id}/invitations": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    /**
     * List invitation metadata without capability tokens.
     * @description Requires owner or administrator membership. Raw invitation capabilities are never returned by list operations.
     */
    get: operations["listInvitations"];
    put?: never;
    /**
     * Create an expiring organization invitation.
     * @description Owners and administrators may invite members or viewers. Only owners may invite administrators. Ownership cannot be granted by invitation. The capability URL is returned exactly once.
     */
    post: operations["createInvitation"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/organizations/{organization_id}/invitations/{invitation_id}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
        invitation_id: components["parameters"]["InvitationId"];
      };
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Revoke a pending organization invitation.
     * @description Owners may revoke any pending invitation. Administrators may revoke member or viewer invitations, but not administrator invitations.
     */
    delete: operations["revokeInvitation"];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/organizations/{organization_id}/projects": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    /** List accessible projects in an organization. */
    get: operations["listProjects"];
    put?: never;
    /** Create a project. */
    post: operations["createProject"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/projects/{project_id}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: components["parameters"]["ProjectId"];
      };
      cookie?: never;
    };
    /** Get one tenant-scoped project. */
    get: operations["getProject"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/projects/{project_id}/documents": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: components["parameters"]["ProjectId"];
      };
      cookie?: never;
    };
    /** List project documents. */
    get: operations["listDocuments"];
    put?: never;
    /** Register a VibeCAD document before its initial checkout and check-in. */
    post: operations["createDocument"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/documents/{document_id}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    /** Get document registration metadata. */
    get: operations["getDocument"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    /** Update document display metadata, never version content. */
    patch: operations["updateDocument"];
    trace?: never;
  };
  "/documents/{document_id}/versions": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    /**
     * List a bounded snapshot of immutable versions, newest first.
     * @description `page_size` bounds this v1 snapshot. Cursor continuation is not supported;
     *     `next_cursor` is always null. Use `page_size=1` to resolve the current
     *     version, with an empty `items` array meaning that none has been published.
     */
    get: operations["listVersions"];
    put?: never;
    /**
     * Publish an immutable version and finish the caller's active checkout.
     * @description Requires an active, unexpired lease owned by the actor. `base_version_id`
     *     must equal both the lease base and the document current version. For a new
     *     document all three are null. The server streams and bounds the file,
     *     calculates SHA-256 itself, compares `expected_sha256`, durably publishes
     *     the blob, commits the version/current pointer/audit atomically in
     *     PostgreSQL, and transitions the lease to `checked_in`. An expired, broken,
     *     or stale lease can only use the recovery-copy endpoint.
     *
     *     This operation persists a completed response for at least 24 hours,
     *     scoped by actor, operation, and `Idempotency-Key`. Repeating the same
     *     canonical metadata and content digest with that key returns the original
     *     Version. Reusing the key with different canonical input returns
     *     `idempotency_key_reused`.
     */
    post: operations["checkInDocument"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/documents/{document_id}/versions/{version_id}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
        version_id: components["parameters"]["VersionId"];
      };
      cookie?: never;
    };
    /** Get immutable version metadata. */
    get: operations["getVersion"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/documents/{document_id}/versions/{version_id}/content": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
        version_id: components["parameters"]["VersionId"];
      };
      cookie?: never;
    };
    /** Stream authorized immutable CAD content. */
    get: operations["downloadVersion"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/documents/{document_id}/checkout": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    /** Get the active or most recently terminal lease visible to the actor. */
    get: operations["getCheckout"];
    put?: never;
    /**
     * Acquire the document's sole active writer lease.
     * @description Serialized in PostgreSQL. At most one active, unexpired lease exists per
     *     document. A completed success is replayable for at least 24 hours when the
     *     same actor repeats the same canonical input and `Idempotency-Key`; different
     *     canonical input with that key returns `idempotency_key_reused`.
     */
    post: operations["acquireCheckout"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/documents/{document_id}/checkout/{lease_id}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
        lease_id: components["parameters"]["LeaseId"];
      };
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /**
     * Release a checkout owned by the actor without publishing.
     * @description A completed success is replayable for at least 24 hours when the same actor
     *     repeats the same canonical input and `Idempotency-Key`; different canonical
     *     input with that key returns `idempotency_key_reused`.
     */
    delete: operations["releaseCheckout"];
    options?: never;
    head?: never;
    /**
     * Renew a checkout owned by the actor.
     * @description Renewal requires the current checkout ETag in `If-Match`, never revives an
     *     expired or terminal lease, and returns an absolute server expiry. A
     *     completed success is replayable for at least 24 hours when the same actor
     *     repeats the same canonical input and `Idempotency-Key`; different canonical
     *     input with that key returns `idempotency_key_reused`.
     */
    patch: operations["renewCheckout"];
    trace?: never;
  };
  "/documents/{document_id}/checkout/{lease_id}/break": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
        lease_id: components["parameters"]["LeaseId"];
      };
      cookie?: never;
    };
    get?: never;
    put?: never;
    /**
     * Administratively break an active checkout.
     * @description Owner/admin only. Requires an explicit reason and emits a high-severity
     *     audit event. A completed success is replayable for at least 24 hours when
     *     the same actor repeats the same canonical input and `Idempotency-Key`;
     *     different canonical input with that key returns `idempotency_key_reused`.
     */
    post: operations["breakCheckout"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/documents/{document_id}/recovery-copies": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    /** List non-current recovery copies. */
    get: operations["listRecoveryCopies"];
    put?: never;
    /**
     * Preserve work after a lost, expired, broken, or stale checkout.
     * @description Never changes the document current version and never creates a Version. A
     *     completed success is replayable for at least 24 hours when the same actor
     *     repeats the same canonical metadata and content digest with the same
     *     `Idempotency-Key`; different canonical input with that key returns
     *     `idempotency_key_reused`.
     */
    post: operations["createRecoveryCopy"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/documents/{document_id}/recovery-copies/{recovery_copy_id}/content": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
        recovery_copy_id: components["parameters"]["RecoveryCopyId"];
      };
      cookie?: never;
    };
    /** Download an authorized recovery copy. */
    get: operations["downloadRecoveryCopy"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/organizations/{organization_id}/audit-events": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    /**
     * List a bounded snapshot of append-only organization audit events.
     * @description `page_size` bounds this v1 snapshot. Cursor continuation is not supported;
     *     `next_cursor` is always null.
     */
    get: operations["listAuditEvents"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/explore": {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    /**
     * List a bounded snapshot of active public listings, newest first.
     * @description Anonymous. Only currently published, non-archived listings are returned.
     *     `page_size` bounds this v1 snapshot. Cursor continuation is not supported;
     *     `next_cursor` is always null. Public responses never include private document
     *     IDs, relative paths, checkout, recovery, or audit state.
     */
    get: operations["listPublicListings"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/explore/{slug}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    /**
     * Get one active public listing.
     * @description Unknown, unpublished, and archived slugs return the same `404 not_found`
     *     problem. The response never includes private document internals.
     */
    get: operations["getPublicListing"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/explore/{slug}/content": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    /**
     * Stream the published immutable FCStd bytes for an active listing.
     * @description Anonymous. The API treats CAD bytes as an opaque stream and never opens,
     *     unzips, or renders them. Unpublished or unknown slugs return `404 not_found`.
     */
    get: operations["downloadPublicListing"];
    put?: never;
    post?: never;
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/explore/{slug}/comments": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    /**
     * List a bounded snapshot of visible comments on an active listing.
     * @description Anonymous readers may list plaintext comments. Soft-deleted comments are
     *     omitted. Unpublished or unknown slugs return `404 not_found`.
     */
    get: operations["listPublicComments"];
    put?: never;
    /**
     * Post a plaintext comment on an active listing.
     * @description Authenticated actors only. Comments are 1-2000 characters with no HTML.
     */
    post: operations["createPublicComment"];
    delete?: never;
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/explore/{slug}/likes": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    get?: never;
    put?: never;
    /** Like an active public listing once per actor. */
    post: operations["likePublicListing"];
    /** Remove the authenticated actor's like from an active listing. */
    delete: operations["unlikePublicListing"];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/explore/{slug}/comments/{comment_id}": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: components["parameters"]["PublicationSlug"];
        comment_id: components["parameters"]["CommentId"];
      };
      cookie?: never;
    };
    get?: never;
    put?: never;
    post?: never;
    /** Soft-delete the authenticated actor's own comment. */
    delete: operations["deletePublicComment"];
    options?: never;
    head?: never;
    patch?: never;
    trace?: never;
  };
  "/documents/{document_id}/publication": {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    /** Get the active publication managed for a document the actor can read. */
    get: operations["getDocumentPublication"];
    put?: never;
    /**
     * Publish one immutable document version as a public listing.
     * @description Owner or admin only. A document may have at most one active listing. The
     *     public slug is generated by the server and is never reused after unpublish.
     *     Publishing an empty document or a document with no versions returns
     *     `validation_failed`.
     */
    post: operations["publishDocument"];
    /**
     * Immediately unpublish the document's active listing.
     * @description Owner or admin only. The slug is retired and public detail, comments,
     *     likes, and content immediately return the same `404 not_found` as an
     *     unknown slug.
     */
    delete: operations["unpublishDocument"];
    options?: never;
    head?: never;
    /**
     * Retarget the listed version or edit public listing metadata.
     * @description Owner or admin only. Omitted fields are left unchanged; empty summary or license clears that field.
     */
    patch: operations["updateDocumentPublication"];
    trace?: never;
  };
}
export type webhooks = Record<string, never>;
export interface components {
  schemas: {
    /** Format: uuid */
    UUID: string;
    /** Format: date-time */
    Timestamp: string;
    /** @example d2a9756e7b1f4fc3389d2077f152f5f932f7280f19f81cb9187f8f0652f9d9e3 */
    SHA256: string;
    /**
     * @description Owner manages ownership; admin manages projects and leases; member can edit; viewer is read-only.
     * @enum {string}
     */
    Role: "owner" | "admin" | "member" | "viewer";
    RegistrationOptionsRequest: {
      handle: string;
      display_name: string;
      /** @description Optional one-time organization invitation capability. Only its SHA-256 hash is retained with the registration challenge. */
      invitation_token?: string;
    };
    RecoveryOptionsRequest: {
      handle: string;
      recovery_code: string;
    };
    PasskeyOptions: {
      challenge_id: components["schemas"]["UUID"];
      /** @description WebAuthn PublicKeyCredentialCreationOptions or PublicKeyCredentialRequestOptions; binary fields use base64url. */
      publicKey: {
        [key: string]: unknown;
      };
    };
    PasskeyFinish: {
      challenge_id: components["schemas"]["UUID"];
      /** @description JSON serialization of the WebAuthn PublicKeyCredential returned by navigator.credentials.create/get. */
      credential: {
        [key: string]: unknown;
      };
    };
    NamedPasskeyFinish: {
      challenge_id: components["schemas"]["UUID"];
      /** @default Passkey */
      name: string;
      /** @description JSON serialization of the WebAuthn PublicKeyCredential returned by navigator.credentials.create. */
      credential: {
        [key: string]: unknown;
      };
    };
    Passkey: {
      id: string;
      name: string;
      created_at: components["schemas"]["Timestamp"];
      /** Format: date-time */
      last_used_at?: string | null;
    };
    PasskeyPage: {
      items: components["schemas"]["Passkey"][];
    };
    RecoveryCodeStatus: {
      active: number;
    };
    RecoveryCodeSet: {
      recovery_codes: string[];
    };
    PairingStart: {
      scopes: ("api:read" | "api:write")[];
    };
    PairingPoll: {
      device_code: string;
    };
    PairingDecision: {
      user_code: string;
      approve: boolean;
    };
    DesktopPairing: {
      device_code: string;
      user_code: string;
      expires_at: components["schemas"]["Timestamp"];
      interval_seconds: number;
    };
    DesktopRefresh: {
      refresh_token: string;
    };
    DesktopCredentialPair: {
      access_token: string;
      expires_at: components["schemas"]["Timestamp"];
      scopes: ("api:read" | "api:write")[];
      refresh_token: string;
      refresh_expires_at: components["schemas"]["Timestamp"];
    };
    AuthSession: {
      actor: components["schemas"]["Actor"];
      csrf_token: string;
    };
    RegistrationComplete: components["schemas"]["AuthSession"] & {
      /** @description One-time display. Each code is Argon2id-hashed server-side and can only bootstrap a replacement passkey. */
      recovery_codes: string[];
      /** @description Present only when this registration atomically consumed an invitation and joined its organization. */
      joined_organization_id?: components["schemas"]["UUID"];
    };
    Actor: {
      id: components["schemas"]["UUID"];
      handle: string;
      display_name: string;
      /** Format: email */
      email?: string | null;
    };
    ActorContext: {
      actor: components["schemas"]["Actor"];
      memberships: components["schemas"]["Membership"][];
    };
    Organization: {
      id: components["schemas"]["UUID"];
      name: string;
      created_at: components["schemas"]["Timestamp"];
      actor_role: components["schemas"]["Role"];
      etag: string;
    };
    CreateOrganization: {
      name: string;
    };
    Membership: {
      id: components["schemas"]["UUID"];
      organization_id: components["schemas"]["UUID"];
      actor: components["schemas"]["Actor"];
      role: components["schemas"]["Role"];
      /** @enum {string} */
      status: "active" | "revoked";
      created_at: components["schemas"]["Timestamp"];
      /** Format: date-time */
      revoked_at?: string | null;
      etag: string;
    };
    CreateMembership: {
      /** @description Exact local account handle for an actor that has already registered. */
      handle: string;
      role: components["schemas"]["Role"];
    };
    /**
     * @description Invitation role; ownership can never be granted by invitation.
     * @enum {string}
     */
    InvitationRole: "admin" | "member" | "viewer";
    InvitationToken: {
      /** @description Raw capability accepted only in a request body and never persisted server-side. */
      token: string;
    };
    Invitation: {
      id: components["schemas"]["UUID"];
      organization_id: components["schemas"]["UUID"];
      organization_name?: string;
      role: components["schemas"]["InvitationRole"];
      /** @enum {string} */
      status: "pending" | "expired" | "revoked" | "accepted";
      created_by: components["schemas"]["UUID"];
      created_at: components["schemas"]["Timestamp"];
      expires_at: components["schemas"]["Timestamp"];
      /** Format: date-time */
      revoked_at?: string | null;
      /** Format: date-time */
      accepted_at?: string | null;
    };
    CreateInvitation: {
      role: components["schemas"]["InvitationRole"];
    };
    CreatedInvitation: {
      invitation: components["schemas"]["Invitation"];
      /** @description Relative same-origin capability URL returned once; list responses never reproduce it. */
      join_url: string;
    };
    UpdateMembership: {
      role?: components["schemas"]["Role"];
      /** @constant */
      status?: "revoked";
    };
    Project: {
      id: components["schemas"]["UUID"];
      organization_id: components["schemas"]["UUID"];
      name: string;
      description?: string;
      created_at: components["schemas"]["Timestamp"];
      etag: string;
    };
    CreateProject: {
      name: string;
      description?: string;
    };
    Document: {
      id: components["schemas"]["UUID"];
      project_id: components["schemas"]["UUID"];
      /** @description Exact persistent FreeCAD `Document.Uid`; immutable after first version publication. */
      native_document_uid: string;
      name: string;
      /** @description Unique project-relative POSIX path; no empty, dot, parent, absolute, drive, or backslash segments. */
      relative_path: string;
      /** @description Reserved compatibility field. API v1 currently returns null; resolve the current Version with `GET /documents/{document_id}/versions?page_size=1`. */
      current_version?: components["schemas"]["Version"] | null;
      /** @description Reserved compatibility field. API v1 currently returns null; read lease state from `GET /documents/{document_id}/checkout`. */
      checkout?: components["schemas"]["CheckoutLease"] | null;
      created_at: components["schemas"]["Timestamp"];
      etag: string;
    };
    CreateDocument: {
      native_document_uid: string;
      name: string;
      relative_path: string;
    };
    UpdateDocument: {
      name?: string;
      relative_path?: string;
    };
    /** @description Immutable after creation. */
    Version: {
      id: components["schemas"]["UUID"];
      document_id: components["schemas"]["UUID"];
      /** Format: int64 */
      sequence: number;
      /** Format: uuid */
      base_version_id?: string | null;
      sha256: components["schemas"]["SHA256"];
      /** Format: int64 */
      size_bytes: number;
      change_message?: string;
      created_by: components["schemas"]["Actor"];
      created_at: components["schemas"]["Timestamp"];
    };
    CheckInMetadata: {
      lease_id: components["schemas"]["UUID"];
      /** Format: uuid */
      base_version_id: string | null;
      expected_sha256: components["schemas"]["SHA256"];
      /** Format: int64 */
      size_bytes: number;
      change_message: string;
    };
    AcquireCheckout: {
      /**
       * Format: uuid
       * @description Non-secret installation/session identifier used in owner-visible diagnostics.
       */
      client_instance_id?: string;
    };
    RenewCheckout: {
      /** Format: uuid */
      client_instance_id: string;
    };
    CheckoutLease: {
      id: components["schemas"]["UUID"];
      document_id: components["schemas"]["UUID"];
      owner: components["schemas"]["Actor"];
      /** @enum {string} */
      state: "active" | "released" | "expired" | "broken" | "checked_in";
      /** Format: uuid */
      base_version_id: string | null;
      /** Format: uuid */
      client_instance_id?: string | null;
      acquired_at: components["schemas"]["Timestamp"];
      /** Format: date-time */
      renewed_at?: string | null;
      expires_at: components["schemas"]["Timestamp"];
      /** Format: date-time */
      terminal_at?: string | null;
      terminal_reason?: string | null;
      etag: string;
    };
    BreakCheckout: {
      reason: string;
    };
    RecoveryMetadata: {
      /** Format: uuid */
      lost_lease_id?: string | null;
      /** Format: uuid */
      base_version_id: string | null;
      expected_sha256: components["schemas"]["SHA256"];
      /** Format: int64 */
      size_bytes: number;
      /** @enum {string} */
      reason:
        | "expired"
        | "broken"
        | "stale_base"
        | "connection_lost"
        | "manual_recovery";
      note?: string;
    };
    RecoveryCopy: {
      id: components["schemas"]["UUID"];
      document_id: components["schemas"]["UUID"];
      /** Format: uuid */
      lost_lease_id?: string | null;
      /** Format: uuid */
      base_version_id: string | null;
      sha256: components["schemas"]["SHA256"];
      /** Format: int64 */
      size_bytes: number;
      reason: string;
      note?: string;
      created_by: components["schemas"]["Actor"];
      created_at: components["schemas"]["Timestamp"];
    };
    /** @description Append-only; actor and target snapshots remain after account/resource removal. */
    AuditEvent: {
      id: components["schemas"]["UUID"];
      organization_id: components["schemas"]["UUID"];
      /** @enum {string} */
      action:
        | "organization.created"
        | "membership.created"
        | "membership.role_changed"
        | "membership.revoked"
        | "project.created"
        | "document.created"
        | "document.metadata_changed"
        | "checkout.acquired"
        | "checkout.renewed"
        | "checkout.released"
        | "checkout.expired"
        | "checkout.broken"
        | "version.published"
        | "recovery_copy.created"
        | "version.downloaded"
        | "recovery_copy.downloaded"
        | "publication.published"
        | "publication.updated"
        | "publication.unpublished";
      /** @enum {string} */
      severity: "info" | "warning" | "high";
      actor: components["schemas"]["Actor"];
      /** @enum {string} */
      target_type:
        | "organization"
        | "membership"
        | "project"
        | "document"
        | "checkout"
        | "version"
        | "recovery_copy"
        | "publication";
      /** Format: uuid */
      target_id?: string | null;
      occurred_at: components["schemas"]["Timestamp"];
      request_id: string;
      /** @description Allowlisted non-secret context; never tokens, file content, or raw request headers. */
      metadata?: {
        [key: string]: unknown;
      };
    };
    PublicAuthor: {
      handle: string;
      display_name: string;
    };
    PublicListing: {
      slug: string;
      title: string;
      summary: string;
      license: string;
      author: components["schemas"]["PublicAuthor"];
      team_name: string;
      published_at: components["schemas"]["Timestamp"];
      /** Format: int64 */
      version_sequence: number;
      sha256: components["schemas"]["SHA256"];
      /** Format: int64 */
      size_bytes: number;
      /** Format: int64 */
      like_count: number;
      liked_by_viewer: boolean;
      /** Format: int64 */
      comment_count: number;
    };
    ManagedPublication: components["schemas"]["PublicListing"] & {
      id: components["schemas"]["UUID"];
      document_id: components["schemas"]["UUID"];
      version_id: components["schemas"]["UUID"];
      organization_id: components["schemas"]["UUID"];
      public_url: string;
      /** Format: date-time */
      unpublished_at?: string | null;
    };
    PublicComment: {
      id: components["schemas"]["UUID"];
      author: components["schemas"]["PublicAuthor"];
      body: string;
      created_at: components["schemas"]["Timestamp"];
    };
    CreatePublicComment: {
      body: string;
    };
    PublishDocument: {
      /**
       * Format: uuid
       * @description Optional immutable version to list. When omitted, the document current version is used.
       */
      version_id?: string;
      title: string;
      summary?: string;
      license?: string;
    };
    UpdatePublication: {
      /** Format: uuid */
      version_id?: string;
      title?: string;
      summary?: string;
      license?: string;
    };
    /** @description Bounded v1 list metadata; cursor continuation is not supported. */
    CursorPage: {
      /** @description Always null in API v1. */
      next_cursor: null;
    };
    Error: {
      /** Format: uri-reference */
      type: string;
      title: string;
      status: number;
      /**
       * @description Stable code; clients branch on this field, never `title` or `detail`.
       * @enum {string}
       */
      code:
        | "authentication_required"
        | "authentication_failed"
        | "recovery_failed"
        | "handle_unavailable"
        | "invitation_unavailable"
        | "cross_origin_denied"
        | "insufficient_scope"
        | "authentication_method_required"
        | "pairing_pending"
        | "pairing_slow_down"
        | "pairing_denied"
        | "pairing_expired"
        | "pairing_decided"
        | "credential_replay"
        | "forbidden"
        | "not_found"
        | "validation_failed"
        | "precondition_required"
        | "precondition_failed"
        | "idempotency_key_reused"
        | "checkout_held"
        | "checkout_not_active"
        | "checkout_not_owned"
        | "checkout_expired"
        | "stale_base_version"
        | "checksum_mismatch"
        | "size_mismatch"
        | "upload_too_large"
        | "already_published"
        | "slug_unavailable"
        | "rate_limited"
        | "internal_error";
      detail?: string;
      request_id: string;
      /** @default false */
      retryable: boolean;
      errors?: {
        field: string;
        code: string;
      }[];
    };
  };
  responses: {
    /** @description Stable machine-readable error. Unauthorized tenant resources return the same 404 shape as absent ones. */
    Error: {
      headers: {
        "X-Request-ID"?: string;
        "Retry-After"?: number;
        [name: string]: unknown;
      };
      content: {
        "application/problem+json": components["schemas"]["Error"];
      };
    };
  };
  parameters: {
    OrganizationId: components["schemas"]["UUID"];
    MembershipId: components["schemas"]["UUID"];
    InvitationId: components["schemas"]["UUID"];
    ProjectId: components["schemas"]["UUID"];
    DocumentId: components["schemas"]["UUID"];
    VersionId: components["schemas"]["UUID"];
    LeaseId: components["schemas"]["UUID"];
    RecoveryCopyId: components["schemas"]["UUID"];
    PublicationSlug: string;
    CommentId: components["schemas"]["UUID"];
    /** @description Opaque base64url credential identifier returned by the passkey inventory. */
    PasskeyId: string;
    /**
     * @description Required client-generated UUID for mutation requests. The server scopes it
     *     by actor and operation. Supplying this header does not by itself guarantee
     *     replay of a prior response: only operations whose descriptions explicitly
     *     promise persisted replay provide that behavior.
     */
    IdempotencyKey: components["schemas"]["UUID"];
    /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
    CSRFToken: string;
    /**
     * @description Required only when renewing a checkout. Supply the strong ETag returned
     *     with the current checkout representation. A missing value returns
     *     `precondition_required`; a stale value returns `precondition_failed`.
     */
    IfMatch: string;
    PageSize: number;
  };
  requestBodies: never;
  headers: never;
  pathItems: never;
}
export type $defs = Record<string, never>;
export interface operations {
  beginPasskeyRegistration: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["RegistrationOptionsRequest"];
      };
    };
    responses: {
      /** @description One-time, five-minute WebAuthn registration challenge bound to the configured origin and RP ID. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PasskeyOptions"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  finishPasskeyRegistration: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PasskeyFinish"];
      };
    };
    responses: {
      /** @description Authenticated local account. Recovery codes are returned once and must be saved now. */
      201: {
        headers: {
          "Set-Cookie"?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["RegistrationComplete"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  beginPasskeyLogin: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description One-time, five-minute WebAuthn assertion challenge requiring user verification. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PasskeyOptions"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  finishPasskeyLogin: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PasskeyFinish"];
      };
    };
    responses: {
      /** @description Authenticated browser session. */
      200: {
        headers: {
          "Set-Cookie"?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["AuthSession"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  beginPasskeyRecovery: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["RecoveryOptionsRequest"];
      };
    };
    responses: {
      /** @description Replacement-passkey registration challenge. No credential is revealed. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PasskeyOptions"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  finishPasskeyRecovery: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PasskeyFinish"];
      };
    };
    responses: {
      /** @description Replacement passkey registered and authenticated. */
      200: {
        headers: {
          "Set-Cookie"?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["AuthSession"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  logoutBrowser: {
    parameters: {
      query?: never;
      header?: {
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Session revoked and cookies expired. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      "4XX": components["responses"]["Error"];
    };
  };
  logoutAllBrowsers: {
    parameters: {
      query?: never;
      header?: {
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description All sessions revoked and current cookies expired. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listPasskeys: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Active passkeys. Credential public keys and authenticator data are never returned. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PasskeyPage"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  beginAdditionalPasskey: {
    parameters: {
      query?: never;
      header?: {
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Actor-bound, one-time WebAuthn registration challenge excluding active credentials. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PasskeyOptions"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  finishAdditionalPasskey: {
    parameters: {
      query?: never;
      header?: {
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["NamedPasskeyFinish"];
      };
    };
    responses: {
      /** @description Passkey added. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Passkey"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  revokePasskey: {
    parameters: {
      query?: never;
      header?: {
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        /** @description Opaque base64url credential identifier returned by the passkey inventory. */
        passkey_id: components["parameters"]["PasskeyId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Passkey revoked. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      "4XX": components["responses"]["Error"];
    };
  };
  getRecoveryCodeStatus: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Recovery-code status; hashes and codes are never returned. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["RecoveryCodeStatus"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  replaceRecoveryCodes: {
    parameters: {
      query?: never;
      header?: {
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description New codes returned once. The user must save them before leaving this response. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["RecoveryCodeSet"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  revokeRecoveryCodes: {
    parameters: {
      query?: never;
      header?: {
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Recovery codes revoked. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      "4XX": components["responses"]["Error"];
    };
  };
  startDesktopPairing: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PairingStart"];
      };
    };
    responses: {
      /** @description Device secret and human approval code, each returned once; only hashes are stored. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["DesktopPairing"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  pollDesktopPairing: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PairingPoll"];
      };
    };
    responses: {
      /** @description Single-delivery scoped access/refresh credential pair. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["DesktopCredentialPair"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  decideDesktopPairing: {
    parameters: {
      query?: never;
      header?: {
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PairingDecision"];
      };
    };
    responses: {
      /** @description Immutable pairing decision recorded. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      "4XX": components["responses"]["Error"];
    };
  };
  refreshDesktopCredential: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["DesktopRefresh"];
      };
    };
    responses: {
      /** @description Rotated access/refresh pair. The prior refresh token is consumed. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["DesktopCredentialPair"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  getCurrentActor: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Current actor. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ActorContext"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  inspectInvitation: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["InvitationToken"];
      };
    };
    responses: {
      /** @description The invitation is pending and available for acceptance. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Invitation"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  acceptInvitation: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["InvitationToken"];
      };
    };
    responses: {
      /** @description Organization membership created from the consumed invitation. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Membership"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listOrganizations: {
    parameters: {
      query?: never;
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Membership-scoped organizations. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            items: components["schemas"]["Organization"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  createOrganization: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path?: never;
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateOrganization"];
      };
    };
    responses: {
      /** @description Organization created. */
      201: {
        headers: {
          Location?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Organization"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  getOrganization: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Organization. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Organization"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listMemberships: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Memberships. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            items: components["schemas"]["Membership"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  createMembership: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateMembership"];
      };
    };
    responses: {
      /** @description Membership created. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Membership"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  updateMembership: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        organization_id: components["parameters"]["OrganizationId"];
        membership_id: components["parameters"]["MembershipId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/merge-patch+json": components["schemas"]["UpdateMembership"];
      };
    };
    responses: {
      /** @description Updated membership. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Membership"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listInvitations: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Organization invitations, including expired, revoked, and accepted metadata. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            items: components["schemas"]["Invitation"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  createInvitation: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateInvitation"];
      };
    };
    responses: {
      /** @description Invitation metadata and one-time-display capability URL. */
      201: {
        headers: {
          Location?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CreatedInvitation"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  revokeInvitation: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        organization_id: components["parameters"]["OrganizationId"];
        invitation_id: components["parameters"]["InvitationId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Invitation revoked. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listProjects: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Projects. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            items: components["schemas"]["Project"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  createProject: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateProject"];
      };
    };
    responses: {
      /** @description Project created. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Project"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  getProject: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: components["parameters"]["ProjectId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Project. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Project"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listDocuments: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        project_id: components["parameters"]["ProjectId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Documents. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            items: components["schemas"]["Document"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  createDocument: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        project_id: components["parameters"]["ProjectId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreateDocument"];
      };
    };
    responses: {
      /** @description Empty document record created. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Document"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  getDocument: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Document. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Document"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  updateDocument: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/merge-patch+json": components["schemas"]["UpdateDocument"];
      };
    };
    responses: {
      /** @description Document updated. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Document"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listVersions: {
    parameters: {
      query?: {
        page_size?: components["parameters"]["PageSize"];
      };
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Versions. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CursorPage"] & {
            items: components["schemas"]["Version"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  checkInDocument: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "multipart/form-data": {
          metadata: components["schemas"]["CheckInMetadata"];
          /**
           * Format: binary
           * @description Opaque FCStd bytes; maximum 1073741824 bytes.
           */
          file: string;
        };
      };
    };
    responses: {
      /** @description Immutable version published and checkout completed. */
      201: {
        headers: {
          /** @description Canonical API path of the published Version resource. */
          Location?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Version"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  getVersion: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
        version_id: components["parameters"]["VersionId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Version metadata. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["Version"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  downloadVersion: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
        version_id: components["parameters"]["VersionId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Opaque version bytes. */
      200: {
        headers: {
          /** @description RFC 9530 SHA-256 content digest. */
          Digest?: string;
          ETag?: string;
          "Content-Length"?: number;
          "Content-Disposition"?: string;
          [name: string]: unknown;
        };
        content: {
          "application/octet-stream": string;
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  getCheckout: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Checkout lease state. */
      200: {
        headers: {
          /** @description Strong checkout ETag for a later renewal's If-Match header. */
          ETag?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CheckoutLease"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  acquireCheckout: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody?: {
      content: {
        "application/json": components["schemas"]["AcquireCheckout"];
      };
    };
    responses: {
      /** @description Checkout acquired. */
      201: {
        headers: {
          /** @description Strong checkout ETag for a later renewal's If-Match header. */
          ETag?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CheckoutLease"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  releaseCheckout: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
        lease_id: components["parameters"]["LeaseId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Lease transitioned to released. */
      200: {
        headers: {
          /** @description Strong ETag of the released checkout. */
          ETag?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CheckoutLease"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  renewCheckout: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required only when renewing a checkout. Supply the strong ETag returned
         *     with the current checkout representation. A missing value returns
         *     `precondition_required`; a stale value returns `precondition_failed`.
         */
        "If-Match": components["parameters"]["IfMatch"];
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
        lease_id: components["parameters"]["LeaseId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/merge-patch+json": components["schemas"]["RenewCheckout"];
      };
    };
    responses: {
      /** @description Lease renewed. */
      200: {
        headers: {
          /** @description Strong ETag of the renewed checkout. */
          ETag?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CheckoutLease"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  breakCheckout: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
        lease_id: components["parameters"]["LeaseId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["BreakCheckout"];
      };
    };
    responses: {
      /** @description Lease transitioned to broken. */
      200: {
        headers: {
          /** @description Strong ETag of the broken checkout. */
          ETag?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CheckoutLease"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listRecoveryCopies: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Recovery copies. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": {
            items: components["schemas"]["RecoveryCopy"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  createRecoveryCopy: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "multipart/form-data": {
          metadata: components["schemas"]["RecoveryMetadata"];
          /**
           * Format: binary
           * @description Opaque FCStd bytes; maximum 1073741824 bytes.
           */
          file: string;
        };
      };
    };
    responses: {
      /** @description Recovery copy preserved without changing current version. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["RecoveryCopy"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  downloadRecoveryCopy: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
        recovery_copy_id: components["parameters"]["RecoveryCopyId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Opaque recovery bytes. */
      200: {
        headers: {
          Digest?: string;
          "Content-Length"?: number;
          [name: string]: unknown;
        };
        content: {
          "application/octet-stream": string;
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listAuditEvents: {
    parameters: {
      query?: {
        page_size?: components["parameters"]["PageSize"];
      };
      header?: never;
      path: {
        organization_id: components["parameters"]["OrganizationId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Audit events in reverse chronological order. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CursorPage"] & {
            items: components["schemas"]["AuditEvent"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listPublicListings: {
    parameters: {
      query?: {
        page_size?: components["parameters"]["PageSize"];
      };
      header?: never;
      path?: never;
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Public listings. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CursorPage"] & {
            items: components["schemas"]["PublicListing"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  getPublicListing: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Public listing. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PublicListing"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  downloadPublicListing: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Opaque published version bytes. */
      200: {
        headers: {
          /** @description RFC 9530 SHA-256 content digest. */
          Digest?: string;
          ETag?: string;
          "Content-Length"?: number;
          "Content-Disposition"?: string;
          [name: string]: unknown;
        };
        content: {
          "application/octet-stream": string;
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  listPublicComments: {
    parameters: {
      query?: {
        page_size?: components["parameters"]["PageSize"];
      };
      header?: never;
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Visible comments, newest first. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["CursorPage"] & {
            items: components["schemas"]["PublicComment"][];
          };
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  createPublicComment: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["CreatePublicComment"];
      };
    };
    responses: {
      /** @description Comment created. */
      201: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PublicComment"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  likePublicListing: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Updated public listing, including the viewer's like state. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PublicListing"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  unlikePublicListing: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        slug: components["parameters"]["PublicationSlug"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Updated public listing. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["PublicListing"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  deletePublicComment: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        slug: components["parameters"]["PublicationSlug"];
        comment_id: components["parameters"]["CommentId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Comment deleted. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      "4XX": components["responses"]["Error"];
    };
  };
  getDocumentPublication: {
    parameters: {
      query?: never;
      header?: never;
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Managed publication, including private document identifiers. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ManagedPublication"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  publishDocument: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/json": components["schemas"]["PublishDocument"];
      };
    };
    responses: {
      /** @description Listing published. */
      201: {
        headers: {
          /** @description Canonical public API path of the listing. */
          Location?: string;
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ManagedPublication"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
  unpublishDocument: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody?: never;
    responses: {
      /** @description Listing unpublished. */
      204: {
        headers: {
          [name: string]: unknown;
        };
        content?: never;
      };
      "4XX": components["responses"]["Error"];
    };
  };
  updateDocumentPublication: {
    parameters: {
      query?: never;
      header: {
        /**
         * @description Required client-generated UUID for mutation requests. The server scopes it
         *     by actor and operation. Supplying this header does not by itself guarantee
         *     replay of a prior response: only operations whose descriptions explicitly
         *     promise persisted replay provide that behavior.
         */
        "Idempotency-Key": components["parameters"]["IdempotencyKey"];
        /** @description Required for unsafe browser-session requests and bound to the session; not used for desktop bearer authentication. */
        "X-CSRF-Token"?: components["parameters"]["CSRFToken"];
      };
      path: {
        document_id: components["parameters"]["DocumentId"];
      };
      cookie?: never;
    };
    requestBody: {
      content: {
        "application/merge-patch+json": components["schemas"]["UpdatePublication"];
        "application/json": components["schemas"]["UpdatePublication"];
      };
    };
    responses: {
      /** @description Listing updated. */
      200: {
        headers: {
          [name: string]: unknown;
        };
        content: {
          "application/json": components["schemas"]["ManagedPublication"];
        };
      };
      "4XX": components["responses"]["Error"];
    };
  };
}

export const API_BASE = "/api/v1" as const;

export type Actor = components["schemas"]["Actor"];
export type ActorContext = components["schemas"]["ActorContext"];
export type Membership = components["schemas"]["Membership"];
export type Organization = components["schemas"]["Organization"];
export type Invitation = components["schemas"]["Invitation"];
export type InvitationRole = components["schemas"]["InvitationRole"];
export type CreatedInvitation = components["schemas"]["CreatedInvitation"];
export type Project = components["schemas"]["Project"];
export type Document = components["schemas"]["Document"];
export type Version = components["schemas"]["Version"];
export type CheckoutLease = components["schemas"]["CheckoutLease"];
export type RecoveryCopy = components["schemas"]["RecoveryCopy"];
export type AuditEvent = components["schemas"]["AuditEvent"];
export type Problem = components["schemas"]["Error"];
export type Role = components["schemas"]["Role"];
export type PasskeyRecord = components["schemas"]["Passkey"];
export type RecoveryCodeStatus = components["schemas"]["RecoveryCodeStatus"];
export type DesktopPairing = components["schemas"]["DesktopPairing"];
export type DesktopCredentialPair =
  components["schemas"]["DesktopCredentialPair"];
export type PublicListing = components["schemas"]["PublicListing"];
export type ManagedPublication = components["schemas"]["ManagedPublication"];
export type PublicComment = components["schemas"]["PublicComment"];
export type PublishDocument = components["schemas"]["PublishDocument"];
export type UpdatePublication = components["schemas"]["UpdatePublication"];

export interface PasskeyOptions<T> {
  challenge_id: string;
  publicKey: T;
}

export interface AuthSession {
  actor: Actor;
  csrf_token: string;
}

export type RegistrationComplete =
  components["schemas"]["RegistrationComplete"];

interface ItemPage<T> {
  items: T[];
  next_cursor?: null;
}

interface RequestOptions extends Omit<RequestInit, "body"> {
  body?: unknown;
}

let csrfToken: string | null = null;

export function setCSRFToken(token: string | null): void {
  csrfToken = token?.trim() || null;
}

function csrfCookie(): string | null {
  if (typeof document === "undefined") return null;
  const prefix = "__Host-vibecloud_csrf=";
  for (const part of document.cookie.split(";")) {
    const candidate = part.trim();
    if (candidate.startsWith(prefix)) {
      try {
        return decodeURIComponent(candidate.slice(prefix.length));
      } catch {
        return null;
      }
    }
  }
  return null;
}

export class APIError extends Error {
  readonly status: number;
  readonly code: Problem["code"];
  readonly requestId: string;
  readonly retryable: boolean;

  constructor(problem: Problem) {
    super(problem.detail || problem.title);
    this.name = "APIError";
    this.status = problem.status;
    this.code = problem.code;
    this.requestId = problem.request_id;
    this.retryable = problem.retryable ?? false;
  }
}

async function request<T>(
  path: string,
  options: RequestOptions = {},
): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set("Accept", "application/json");
  const method = (options.method ?? "GET").toUpperCase();
  if (!["GET", "HEAD", "OPTIONS"].includes(method)) {
    const token = csrfToken ?? csrfCookie();
    if (token) headers.set("X-CSRF-Token", token);
  }
  let body: BodyInit | undefined;
  if (options.body !== undefined) {
    headers.set("Content-Type", "application/json");
    body = JSON.stringify(options.body);
  }
  const response = await fetch(`${API_BASE}${path}`, {
    ...options,
    body,
    credentials: "same-origin",
    headers,
  });
  if (!response.ok) throw await responseError(response);
  if (response.status === 204) return undefined as T;
  return (await response.json()) as T;
}

async function responseError(response: Response): Promise<APIError> {
  const contentType = response.headers.get("Content-Type") ?? "";
  if (
    contentType.includes("application/problem+json") ||
    contentType.includes("application/json")
  ) {
    try {
      return new APIError((await response.json()) as Problem);
    } catch {
      // Fall through when an intermediary declared JSON but returned junk.
    }
  }
  return new APIError({
    type: "about:blank",
    title: "Request failed",
    status: response.status,
    code: response.status === 404 ? "not_found" : "internal_error",
    request_id: response.headers.get("X-Request-ID") ?? "unavailable",
    retryable: response.status >= 500,
  });
}

async function download(path: string, filename: string): Promise<void> {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: "same-origin",
    headers: { Accept: "application/octet-stream" },
  });
  if (!response.ok) throw await responseError(response);
  const objectURL = URL.createObjectURL(await response.blob());
  try {
    const link = window.document.createElement("a");
    link.href = objectURL;
    link.download = filename.replace(/[\\/\0]/g, "_");
    link.style.display = "none";
    window.document.body.append(link);
    link.click();
    link.remove();
  } finally {
    window.setTimeout(() => URL.revokeObjectURL(objectURL), 0);
  }
}

function idempotencyHeaders(): HeadersInit {
  return { "Idempotency-Key": crypto.randomUUID() };
}

export const api = {
  me: (): Promise<ActorContext> => request<ActorContext>("/me"),
  registerOptions: (
    handle: string,
    displayName: string,
    invitationToken?: string,
  ): Promise<PasskeyOptions<unknown>> =>
    request<PasskeyOptions<unknown>>("/auth/register/options", {
      method: "POST",
      body: {
        handle,
        display_name: displayName,
        ...(invitationToken ? { invitation_token: invitationToken } : {}),
      },
    }),
  registerVerify: (
    challengeId: string,
    credential: unknown,
  ): Promise<RegistrationComplete> =>
    request<RegistrationComplete>("/auth/register/verify", {
      method: "POST",
      body: { challenge_id: challengeId, credential },
    }),
  loginOptions: (): Promise<PasskeyOptions<unknown>> =>
    request<PasskeyOptions<unknown>>("/auth/login/options", { method: "POST" }),
  loginVerify: (
    challengeId: string,
    credential: unknown,
  ): Promise<AuthSession> =>
    request<AuthSession>("/auth/login/verify", {
      method: "POST",
      body: { challenge_id: challengeId, credential },
    }),
  recoveryOptions: (
    handle: string,
    recoveryCode: string,
  ): Promise<PasskeyOptions<unknown>> =>
    request<PasskeyOptions<unknown>>("/auth/recovery/options", {
      method: "POST",
      body: { handle, recovery_code: recoveryCode },
    }),
  recoveryVerify: (
    challengeId: string,
    credential: unknown,
  ): Promise<AuthSession> =>
    request<AuthSession>("/auth/recovery/verify", {
      method: "POST",
      body: { challenge_id: challengeId, credential },
    }),
  logout: (): Promise<void> =>
    request<void>("/auth/logout", { method: "POST" }),
  logoutAll: (): Promise<void> =>
    request<void>("/auth/logout-all", { method: "POST" }),
  passkeys: (): Promise<ItemPage<PasskeyRecord>> =>
    request<ItemPage<PasskeyRecord>>("/auth/passkeys"),
  addPasskeyOptions: (): Promise<PasskeyOptions<unknown>> =>
    request<PasskeyOptions<unknown>>("/auth/passkeys/options", {
      method: "POST",
    }),
  addPasskeyVerify: (
    challengeId: string,
    name: string,
    credential: unknown,
  ): Promise<PasskeyRecord> =>
    request<PasskeyRecord>("/auth/passkeys/verify", {
      method: "POST",
      body: { challenge_id: challengeId, name, credential },
    }),
  revokePasskey: (passkeyId: string): Promise<void> =>
    request<void>(`/auth/passkeys/${encodeURIComponent(passkeyId)}`, {
      method: "DELETE",
    }),
  recoveryCodeStatus: (): Promise<RecoveryCodeStatus> =>
    request<RecoveryCodeStatus>("/auth/recovery-codes"),
  replaceRecoveryCodes: (): Promise<{ recovery_codes: string[] }> =>
    request<{ recovery_codes: string[] }>("/auth/recovery-codes", {
      method: "POST",
    }),
  revokeRecoveryCodes: (): Promise<void> =>
    request<void>("/auth/recovery-codes", { method: "DELETE" }),
  decidePairing: (userCode: string, approve: boolean): Promise<void> =>
    request<void>("/auth/device/pairings/decision", {
      method: "POST",
      body: { user_code: userCode, approve },
    }),
  inspectInvitation: (token: string): Promise<Invitation> =>
    request<Invitation>("/invitations/inspect", {
      method: "POST",
      body: { token },
    }),
  acceptInvitation: (token: string): Promise<Membership> =>
    request<Membership>("/invitations/accept", {
      method: "POST",
      headers: idempotencyHeaders(),
      body: { token },
    }),
  organizations: (): Promise<ItemPage<Organization>> =>
    request<ItemPage<Organization>>("/organizations"),
  createOrganization: (name: string): Promise<Organization> =>
    request<Organization>("/organizations", {
      method: "POST",
      headers: idempotencyHeaders(),
      body: { name },
    }),
  organization: (organizationId: string): Promise<Organization> =>
    request<Organization>(
      `/organizations/${encodeURIComponent(organizationId)}`,
    ),
  memberships: (organizationId: string): Promise<ItemPage<Membership>> =>
    request<ItemPage<Membership>>(
      `/organizations/${encodeURIComponent(organizationId)}/memberships`,
    ),
  invitations: (organizationId: string): Promise<ItemPage<Invitation>> =>
    request<ItemPage<Invitation>>(
      `/organizations/${encodeURIComponent(organizationId)}/invitations`,
    ),
  createInvitation: (
    organizationId: string,
    role: InvitationRole,
  ): Promise<CreatedInvitation> =>
    request<CreatedInvitation>(
      `/organizations/${encodeURIComponent(organizationId)}/invitations`,
      {
        method: "POST",
        headers: idempotencyHeaders(),
        body: { role },
      },
    ),
  revokeInvitation: (
    organizationId: string,
    invitationId: string,
  ): Promise<void> =>
    request<void>(
      `/organizations/${encodeURIComponent(organizationId)}/invitations/${encodeURIComponent(invitationId)}`,
      {
        method: "DELETE",
        headers: idempotencyHeaders(),
      },
    ),
  projects: (organizationId: string): Promise<ItemPage<Project>> =>
    request<ItemPage<Project>>(
      `/organizations/${encodeURIComponent(organizationId)}/projects`,
    ),
  createProject: (
    organizationId: string,
    name: string,
    description: string,
  ): Promise<Project> =>
    request<Project>(
      `/organizations/${encodeURIComponent(organizationId)}/projects`,
      {
        method: "POST",
        headers: idempotencyHeaders(),
        body: { name, ...(description ? { description } : {}) },
      },
    ),
  project: (projectId: string): Promise<Project> =>
    request<Project>(`/projects/${encodeURIComponent(projectId)}`),
  documents: (projectId: string): Promise<ItemPage<Document>> =>
    request<ItemPage<Document>>(
      `/projects/${encodeURIComponent(projectId)}/documents`,
    ),
  document: (documentId: string): Promise<Document> =>
    request<Document>(`/documents/${encodeURIComponent(documentId)}`),
  versions: (documentId: string): Promise<ItemPage<Version>> =>
    request<ItemPage<Version>>(
      `/documents/${encodeURIComponent(documentId)}/versions`,
    ),
  recoveryCopies: (documentId: string): Promise<ItemPage<RecoveryCopy>> =>
    request<ItemPage<RecoveryCopy>>(
      `/documents/${encodeURIComponent(documentId)}/recovery-copies`,
    ),
  checkout: (documentId: string): Promise<CheckoutLease> =>
    request<CheckoutLease>(
      `/documents/${encodeURIComponent(documentId)}/checkout`,
    ),
  auditEvents: (organizationId: string): Promise<ItemPage<AuditEvent>> =>
    request<ItemPage<AuditEvent>>(
      `/organizations/${encodeURIComponent(organizationId)}/audit-events`,
    ),
  breakCheckout: (
    documentId: string,
    leaseId: string,
    reason: string,
  ): Promise<CheckoutLease> =>
    request<CheckoutLease>(
      `/documents/${encodeURIComponent(documentId)}/checkout/${encodeURIComponent(leaseId)}/break`,
      { method: "POST", headers: idempotencyHeaders(), body: { reason } },
    ),
  downloadVersion: (
    documentId: string,
    versionId: string,
    filename: string,
  ): Promise<void> =>
    download(
      `/documents/${encodeURIComponent(documentId)}/versions/${encodeURIComponent(versionId)}/content`,
      filename,
    ),
  downloadRecoveryCopy: (
    documentId: string,
    recoveryCopyId: string,
    filename: string,
  ): Promise<void> =>
    download(
      `/documents/${encodeURIComponent(documentId)}/recovery-copies/${encodeURIComponent(recoveryCopyId)}/content`,
      filename,
    ),
  explore: (pageSize = 50): Promise<ItemPage<PublicListing>> =>
    request<ItemPage<PublicListing>>(
      `/explore?page_size=${encodeURIComponent(String(pageSize))}`,
    ),
  publicListing: (slug: string): Promise<PublicListing> =>
    request<PublicListing>(`/explore/${encodeURIComponent(slug)}`),
  publicComments: (
    slug: string,
    pageSize = 50,
  ): Promise<ItemPage<PublicComment>> =>
    request<ItemPage<PublicComment>>(
      `/explore/${encodeURIComponent(slug)}/comments?page_size=${encodeURIComponent(String(pageSize))}`,
    ),
  likePublicListing: (slug: string): Promise<PublicListing> =>
    request<PublicListing>(`/explore/${encodeURIComponent(slug)}/likes`, {
      method: "POST",
      headers: idempotencyHeaders(),
    }),
  unlikePublicListing: (slug: string): Promise<PublicListing> =>
    request<PublicListing>(`/explore/${encodeURIComponent(slug)}/likes`, {
      method: "DELETE",
      headers: idempotencyHeaders(),
    }),
  createPublicComment: (slug: string, body: string): Promise<PublicComment> =>
    request<PublicComment>(`/explore/${encodeURIComponent(slug)}/comments`, {
      method: "POST",
      headers: idempotencyHeaders(),
      body: { body },
    }),
  deletePublicComment: (slug: string, commentId: string): Promise<void> =>
    request<void>(
      `/explore/${encodeURIComponent(slug)}/comments/${encodeURIComponent(commentId)}`,
      { method: "DELETE", headers: idempotencyHeaders() },
    ),
  downloadPublicListing: (slug: string, filename: string): Promise<void> =>
    download(`/explore/${encodeURIComponent(slug)}/content`, filename),
  publication: (documentId: string): Promise<ManagedPublication> =>
    request<ManagedPublication>(
      `/documents/${encodeURIComponent(documentId)}/publication`,
    ),
  publishDocument: (
    documentId: string,
    input: PublishDocument,
  ): Promise<ManagedPublication> =>
    request<ManagedPublication>(
      `/documents/${encodeURIComponent(documentId)}/publication`,
      {
        method: "POST",
        headers: idempotencyHeaders(),
        body: input,
      },
    ),
  updatePublication: (
    documentId: string,
    input: UpdatePublication,
  ): Promise<ManagedPublication> =>
    request<ManagedPublication>(
      `/documents/${encodeURIComponent(documentId)}/publication`,
      {
        method: "PATCH",
        headers: idempotencyHeaders(),
        body: input,
      },
    ),
  unpublishDocument: (documentId: string): Promise<void> =>
    request<void>(`/documents/${encodeURIComponent(documentId)}/publication`, {
      method: "DELETE",
      headers: idempotencyHeaders(),
    }),
};
